const comments = [
  {
    name: '追剧达人小王',
    time: '2小时前',
    content: '天狼影院真的太良心了！高清不卡顿，更新速度也快，追剧神器没跑了。最近在追星辰大海，画质超棒！',
    likes: 128,
  },
  {
    name: '电影爱好者老李',
    time: '5小时前',
    content: '用了好几个平台，天狼影院的播放体验是最好的，即点即播不用等，而且资源真的很全，国产剧韩剧都有。',
    likes: 96,
  },
  {
    name: '综艺迷小陈',
    time: '8小时前',
    content: '周末在家刷了一整天综艺，欢乐喜剧人第八季太搞笑了！天狼影院更新速度杠杠的，推荐给所有喜欢看综艺的朋友。',
    likes: 75,
  },
  {
    name: '动漫控阿杰',
    time: '12小时前',
    content: '山海传说画面太美了！国漫真的越来越强了，感谢天狼影院提供这么好的观影平台，画质清晰流畅无压力。',
    likes: 63,
  },
  {
    name: '剧评人小美',
    time: '1天前',
    content: '作为影视博主，天狼影院是我日常找素材的重要渠道。资源覆盖面广，从热门剧到小众纪录片都有，强烈推荐！',
    likes: 51,
  },
];

export default function SectionComments() {
  return (
    <section id="comments" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            观众热评
          </h2>
          <p className="text-sm text-foreground-500">来自天狼影院用户的真实评价</p>
        </div>
        <div className="space-y-4">
          {comments.map((comment, i) => (
            <div
              key={i}
              className="bg-background-100 rounded-lg p-5 border border-background-200"
            >
              <div className="flex items-center justify-between mb-3">
                <div className="flex items-center gap-3">
                  <div className="w-9 h-9 rounded-full bg-secondary-200 flex items-center justify-center">
                    <span className="text-sm font-bold text-secondary-700">
                      {comment.name.charAt(0)}
                    </span>
                  </div>
                  <div>
                    <p className="text-sm font-medium text-foreground-900">{comment.name}</p>
                    <p className="text-xs text-foreground-400">{comment.time}</p>
                  </div>
                </div>
                <div className="flex items-center gap-1 text-foreground-400">
                  <i className="ri-thumb-up-line text-xs"></i>
                  <span className="text-xs">{comment.likes}</span>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">{comment.content}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}